import React from "react";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { Amplify } from "aws-amplify";

import App from "./App";
import { persistor, store } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import awsExports from "./aws-exports";
import ToastMessage from "./components/ToastMessage/ToastMessage";
import "./index.css";
import "./custom.scss";

const container = document.getElementById("root")!;
const root = createRoot(container);

Amplify.configure(awsExports);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <ToastMessage />
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
